import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, IconButton } from "@mui/material";
import PropTypes from "prop-types";

function CustomToolTip({ info = "Additional information", styleObj }) {
    return (
        <div style={styleObj}>
            <Tooltip title={info}>
                <IconButton>
                    <InfoIcon />
                </IconButton>
            </Tooltip>
        </div>
    )
}

CustomToolTip.propTypes = {
    info: PropTypes.string.isRequired,
    styleObj: PropTypes.object
};

export default CustomToolTip